export const SHOP_ROUTES = {
  COMFIRMATION: '/shop/cart/payment/success' as const,
  CATEGORIES: '/shop/categories/overview/' as const,
  CATEGORY: {
    DEFAULT: (category: string) =>
      `/shop/category/overview/?category=${category.replace(/\s/g, '')}` as const,
    CYOD: (category: string, group: number) =>
      `/shop/cyod/products/overview?category=${category.replace(/\s/g, '')}&group=${group}` as const,
  },

  PRODUCT: (slug: string) => `/shop/product/overview/?slug=${slug}` as const,
  PRODUCTDETAIL: (slug: string, filename: string, category: string) =>
    `/shop/product/overview?slug=${slug}&filename=${filename}&category=${category}` as const,

  CYOD: {
    OVERVIEW: (slug: string) => `/shop/cyod/overview?slug=${slug}` as const,
    CATEGORIES: (group: number) =>
      `/shop/cyod/categories/overview?group=${group}` as const,
  },

  PAYMENT: '/shop/cart/payment' as const,
  CANCEL: (orderId?: number, reason?: string) =>
    `/shop/cart/payment/cancel?orderId=${orderId}&reason=${reason}` as const,
  SUCCESS: '/shop/cart/payment/success' as const,
  EXTERNAL: {
    IMAGE: (filename: string, extention: string) =>
      `https://shop.cmcgroup.be/assets/upload/product/${filename}.${extention}` as const,
    CATEGORYIMAGE: (categoryId: number, extention: string) =>
      `https://shop.cmcgroup.be/assets/upload/category/category-${categoryId}.${extention}` as const,
  },
};
